export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/wmd-logo-warmup-english-0af7916f8de815a887bc04c75d2e627c.svg";